const TP_STAR = "M12 1.6l2.6 6.95 7.4.3-5.8 4.6 2 7.15L12 16.9l-6.2 4.3 2-7.15-5.8-4.6 7.4-.3z";

import Tick from "@/public/icons/jade-tick.svg";

const TpStars = ({ size = 22, fiveStar = true }: { size?: number; fiveStar?: boolean }) => (
  <span className="inline-flex" style={{ gap: size < 24 ? 3 : 4 }}>
    {(fiveStar ? [0, 1, 2, 3, 4] : [0, 1, 2, 3]).map((i) => (
      <span
        key={i}
        className="inline-flex items-center justify-center rounded-[2px] bg-[#00B67A]"
        style={{ width: size, height: size }}
      >
        <svg viewBox="0 0 24 24" width={size * 0.74} height={size * 0.74}>
          <path d={TP_STAR} fill="#fff" />
        </svg>
      </span>
    ))}
    {!fiveStar && (
      <span
        key="last"
        className="inline-flex items-center justify-center rounded-[2px] bg-[linear-gradient(90deg,#00B67A_1.43%,#7BD5BD_51.05%,#F0F3FD_98.57%)]"
        style={{ width: size, height: size }}
      >
        <svg viewBox="0 0 24 24" width={size * 0.74} height={size * 0.74}>
          <path d={TP_STAR} fill="#fff" />
        </svg>
      </span>
    )}
  </span>
);

/* Only one approved customer quote exists today (from components/customer-reviews/Testimonials) —
   the grid supports more cards, but content must come from marketing/CS, never be invented. */
const REVIEWS = [
  {
    headline: "Simple, effective, and easy to communicate with",
    body: "We really liked how simple and effective the whole process was. At first we thought the offer was too good to be true — but the fact that it was so easy to communicate with everyone in the team made it so seamless because we could pick up the phone or email anyone if we had any issues or concerns.",
    name: "Steve & Ashna",
    who: "First time buyers",
    initials: "S&A",
    date: "May 2026",
  },
  {
    headline: "Excellent team",
    body: "What more can I say about Keyzy? Words are not enough to express our gratitude. Keyzy helped us achieve our dream home, along with excellent amenities and outstanding service throughout the journey.\n\nI would sincerely request the Keyzy team to continue the same energy, dedication, and customer-focused approach for everyone who is planning or working towards building their dream home in London.",
    name: "Lata Gowda",
    initials: "LG",
    who: "Harrow, HA1",
    date: "May 2026",
  },
  {
    headline: "Keyze came to rescue just as I was…",
    body: "Keyze came to rescue just as I was giving up on my dream to own a home! When I first came to see the property it felt like too good to be true, but then it was also lucrative enough for me to find out bit more. Such an innovative idea, although fairly new concept - I do not doubt this business model will turn out to be a successful one. I am saying this after all my due diligence and finally deciding to go with Keyze property! The move was smooth, Simon and Jeremy were both wonderful, with a lot of patience and very accommodating with all my queries and even met me face to face as I was seeking reassurance.  They are highly responsive and took any issues/concerns very seriously and dealt with it immediately (a small hick-up in my case). I could not recommend Keyze enough, it was a smooth transaction and I am made to feel at home with my pets and couple of changes I wanted to make, they have relaxed and chilled approach as such it’s easier to feel at home from day 1. I am absolutely in love with the property, quality of fixture fittings and the area is suitable, I can enjoy walks with my cats; park and convenience shops near by. I am looking forward to the summer and certainly many more years once the purchase has gone through in 2 years time. I feel comfortable that my dream is in good hands. The extra offer for key workers was added benefit and I am certainly recommending Keyze to all my work colleagues & friends. I wish Keyze a full success within short span of time. All the very best Simon, Jeremy. And a big thank you!",
    name: "Farhana",
    initials: "F",
    who: "Harrow, HA1",
    date: "Mar 2026",
  },
  {
    headline: "Moved in the Green Quarter in Southall…",
    body: "moved in the green quarter in southall just over a month ago. From the day we made the enquiry with keyzy up until now everything has been so easy. Never have to wait for them to response. Even after sale service has been brilliant. At the start we felt like it was too good to be true but their dedication from the get go has been incredible. Would like to specially mention Simon who dealt with us from the start, answered any questions we had very quickly and also helped us while we were moving from our old place by organising us to take our furniture earlier. Always been very responsive no matter when and what we asked for. Looking forward to this new chapter of our lives and it wouldn't of been possible if we hadn't found Keyzy.",
    name: "Hamza",
    initials: "H",
    who: "Southall, UB1",
    date: "Feb 2026",
  },
];
const initialsBackgroundColors = ["#F39237", "#BF1363", "#1279B4"];
const Testimonials = () => (
  <section className="bg-landing-ivory py-16 md:py-20">
    <div className="px-5 lg:px-20 mx-auto max-w-7xl">
      <div className="text-center mb-12">
        <div className="inline-flex flex-wrap justify-center items-center gap-4 mb-7">
          <TpStars size={30} fiveStar={false} />
          <div className="flex flex-col gap-0.5 text-left">
            <a
              href="https://www.trustpilot.com/review/keyzy.com"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-1 text-sm text-landing-darkGray hover:underline"
            >
              <p className="text-base font-bold text-landing-lightGray leading-[19.2px]">
                Excellent · <span className="font-semibold">4.5 out of 5</span>
              </p>
            </a>
          </div>
        </div>
        <h2 className="text-3xl md:text-5xl font-bold text-landing-blue mb-3">
          Loved by Keyzy homeowners
        </h2>
        <p className="font-serif text-lg md:text-2xl text-landing-blue/70 max-w-[46ch] mx-auto">
          Real stories from people who swapped renting for owning —<br /> verified on Trustpilot.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5 items-start">
        {REVIEWS.map((r, index) => (
          <article
            key={r.name}
            className="bg-white rounded-2xl p-6 shadow-sm hover:shadow-lg hover:-translate-y-0.5 transition-all duration-300 ease-out flex flex-col gap-3.5 h-full"
          >
            <div className="flex items-center justify-between">
              <TpStars size={20} />
              <span className="inline-flex items-center justify-center w-[26px] h-[26px] rounded-md bg-[#00B67A]/10">
                <svg viewBox="0 0 24 24" width={14} height={14}>
                  <path d={TP_STAR} fill="#00B67A" />
                </svg>
              </span>
            </div>
            <h3 className="text-lg font-bold text-landing-blue">{r.headline}</h3>
            <p
              className="text-[15px] text-landing-blue/70 leading-relaxed flex-1 overflow-hidden text-justify"
              style={{ display: "-webkit-box", WebkitLineClamp: 14, WebkitBoxOrient: "vertical" }}
            >
              {r.body}
            </p>
            <div className="flex gap-3 items-center pt-4 border-t border-landing-blue/10">
              <div
                className="row-span-2 w-10 h-10 rounded-full text-white font-bold flex items-center justify-center text-sm"
                style={{ backgroundColor: initialsBackgroundColors[index % 3] }}
              >
                {r.initials}
              </div>
              <div className="flex flex-col gap-0.5">
                <span className="font-bold text-sm text-landing-blue">{r.name}</span>
                <span className="text-xs text-landing-darkGray">{r.who}</span>
                <div className="flex items-center gap-1 ">
                  <Tick />
                  <p className="text-jade font-semibold text-xs leading-3">Verified · {r.date}</p>
                </div>
              </div>
            </div>
          </article>
        ))}
      </div>
    </div>
  </section>
);

export default Testimonials;
